import { helper } from '@ember/component/helper';

import { titleize } from 'rise-ui/utils/string.js';

const map = {
  'one minute': 'One-Minute',
  'five minute': 'Five-Minute',
  'fifteen minute': 'Fifteen-Minute',
  biannually: 'Biannual',
  'annual (water year)': 'Annual (Calendar Year)',
  biennially: 'Biennial',
};

export default helper(function parameterTimestepHelper([ value ]) {
  value = (value || '') + '';
  const key = value.toLowerCase();
  return key in map ? map[key] : titleize(value);
});
